import type { MouseEvent, PropsWithChildren } from 'react';

import { cn } from 'cn';

type P = PropsWithChildren<{
  href?: string;
  isActive?: boolean;
  onClick?: (event: MouseEvent<HTMLAnchorElement>) => void;
}>;

/**
 * Clickable anchor wrapper that triggers navigation to a form section.
 */
export function TreeAction({
  children,
  href = '',
  isActive = false,
  onClick,
}: P) {
  return (
    <a
      className={cn(
        'block truncate text-left duration-150 ease-out',
        isActive
          ? 'cursor-default'
          : 'cursor-pointer transition-all hover:font-medium hover:text-tiga-action-lighter',
      )}
      data-tree-viewer-active={isActive || undefined}
      href={href}
      onMouseDown={onClick}
      onClick={(event) => {
        event.preventDefault();
        event.stopPropagation();
      }}
      role="button"
    >
      {children}
    </a>
  );
}
